import React, { memo } from 'react';
import { SIZES, Typography } from '@fupa/fupa-uikit';
import styled from 'styled-components';
const Wrapper = styled.div.withConfig({
  componentId: "sc-1p1x8lf-0"
})(["display:", ";position:absolute;bottom:", ";left:0;text-align:left;background-color:rgba(0,0,0,0.6);padding:", ";height:", ";line-height:", ";z-index:9999;"], props => props.show ? 'block' : 'none', SIZES['32'], SIZES['8'], SIZES['36'], SIZES['20']);
const WhiteTypography = styled(Typography).withConfig({
  componentId: "sc-1p1x8lf-1"
})(["color:white;display:block;"]);
const CountdownTimer = _ref => {
  let {
    remainingTime,
    show
  } = _ref;
  if (!remainingTime) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Wrapper, {
    show: show,
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "CountdownTimer",
    "data-sentry-source-file": "CountdownTimer.tsx"
  }, /*#__PURE__*/React.createElement(WhiteTypography, {
    variant: "body1",
    "data-sentry-element": "WhiteTypography",
    "data-sentry-source-file": "CountdownTimer.tsx"
  }, "Werbung 0:", remainingTime));
};
export default /*#__PURE__*/memo(CountdownTimer);